import {apiGetTaxReports} from "api/reportApi";

import {PriceComponent} from "components/Table/CellComponents";

const taxReportColumns = [
    {
        name: "کد حسابداری",
        key: "accountingCode",
        size: "2",
        disableSearch: true,
    },
    {
        name: "تاریخ",
        key: "date",
        size: "3",
        searchType: "date",
        disableSearch: true,
    },
    {
        name: "عنوان",
        key: "title",
        size: "7",
        navigateKey: (item: any) => item.productId,
        navigate: "/reports/productsAccountCard?productId=",
        searchType: "autocomplete",
        dataKey: {
            column: "products",
            key: "title",
        },
        disableSearch: true,
    },
    {
        name: "شخص",
        key: "person",
        size: "3",
        navigateKey: (item: any) => item.personId,
        navigate: "/reports/personalAccountCard?personId=",
        searchType: "autocomplete",
        dataKey: {
            column: "persons",
            key: "nickName",
        },
        disableSearch: true,
    },
    {
        name: "مبلغ",
        key: "price",
        size: "3",
        Component: PriceComponent,
        searchType: "quantitative",
        disableSearch: true,
    },
    {
        name: "عوارض",
        key: "taxation",
        size: "3",
        Component: PriceComponent,
        searchType: "quantitative",
        disableSearch: true,
    },
    {
        name: "مالیات",
        key: "taxFactor",
        size: "3",
        Component: PriceComponent,
        searchType: "quantitative",
        disableSearch: true,
    },
    {
        name: "کل مبلغ",
        key: "totalPrice",
        size: "3",
        Component: PriceComponent,
        searchType: "quantitative",
        disableSearch: true,
    },
];

export const taxReportIndexData = [
    {
        key: "taxReport",
        label: "گزارش مالیات",
        pluralLabel: "گزارش مالیات",
        disableSearch: true,
        title: "گزارش مالیات",
        pageTitle: "گزارش مالیات",
        // pageDescription: "نمایش کالا و خدمات کسب و کار",
        tableColumns: taxReportColumns,
        actions: {
            back: {},
            fetch: apiGetTaxReports,
        },
    },
];
